export const preferDefault = (m: any): any => (m && m.default) || m
